"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderMonthTilLastDayExpireFit = exports.fitExpireDateExtraDays = exports.fitExpireDate = exports.expireDate = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
/**
 * 만기일 맞춤 만기일(종료일) 계산
 * @param startDate (YYYY-MM-DD)
 * @param orderMonth
 */
function expireDate(startDate, orderMonth) {
    const startDateDayjs = (0, dayjs_1.default)(startDate, 'YYYY-MM-DD');
    const expireDateDayjs = startDateDayjs.add(orderMonth, 'month');
    return expireDateDayjs.format('YYYY-MM-DD');
}
exports.expireDate = expireDate;
/**
 * 만기일 맞춤 만기일(종료일) 계산
 * @param startDate (YYYY-MM-DD)
 * @param orderMonth
 */
function fitExpireDate(startDate, orderMonth) {
    const startDateDayjs = (0, dayjs_1.default)(startDate, 'YYYY-MM-DD');
    let expireDateDayjs = startDateDayjs.add(orderMonth, 'month');
    const orderDay = startDateDayjs.date();
    if (orderDay < 16) {
        expireDateDayjs = expireDateDayjs.subtract(1, 'month');
    }
    return expireDateDayjs.endOf('month').format('YYYY-MM-DD');
}
exports.fitExpireDate = fitExpireDate;
/**
 * 만기일 조정 기간(일) 계산
 * @param startDate (YYYY-MM-DD)
 */
function fitExpireDateExtraDays(startDate) {
    const startDateDayjs = (0, dayjs_1.default)(startDate, 'YYYY-MM-DD');
    const orderDay = startDateDayjs.date();
    const lastDay = startDateDayjs.endOf('month').date();
    if (orderDay < 16) {
        return lastDay - 30 - orderDay;
    }
    else {
        return lastDay - orderDay;
    }
}
exports.fitExpireDateExtraDays = fitExpireDateExtraDays;
/**
 * 시작일과 종료일(만기일 맞춤) 사이의 주문 기간 계산
 * -1 응답 : 계산 오류
 * -2 응답 : 시작일 > 종료일 파라미터 오류
 * -3 응답 : endDate 파라미터 오류(말일이 아님)
 * @param startDate (YYYY-MM-DD)
 * @param endDate (YYYY-MM-DD)
 */
function orderMonthTilLastDayExpireFit(startDate, endDate) {
    const startDateObj = (0, dayjs_1.default)(startDate, 'YYYY-MM-DD');
    const endDateObj = (0, dayjs_1.default)(endDate, 'YYYY-MM-DD');
    if (startDateObj.isAfter(endDateObj)) {
        return -2;
    }
    // endDate 말일 검증
    const endDateObjClone = endDateObj.clone();
    if (endDateObjClone.date() !== endDateObjClone.endOf('month').date()) {
        return -3;
    }
    let orderMonth = endDateObj.diff(startDateObj, 'month');
    // 만기일 전월 맞춤 케이스
    if (startDateObj.date() < 16) {
        orderMonth++;
    }
    // 계산 검증
    const fitLastDayDateString = fitExpireDate(startDate, orderMonth);
    if (fitLastDayDateString !== endDate) {
        return -1;
    }
    return orderMonth;
}
exports.orderMonthTilLastDayExpireFit = orderMonthTilLastDayExpireFit;
exports.default = {
    expireDate,
    fitExpireDate,
    fitExpireDateExtraDays,
    orderMonthTilLastDayExpireFit,
};
